import { Component, HostListener, OnInit, Inject, Renderer2, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { LatestService } from 'src/app/service/latest/latest.service';
import { PageEvent } from "@angular/material/paginator";
import { Router } from '@angular/router';
import { DESCIPTION_BASE, TITLE_LATEST } from 'src/app/constant/app-constant';
import { Meta, Title } from '@angular/platform-browser';
import { CanonicalService } from 'src/app/service/canonical/canonical.service';
import { MetaTagsService } from 'src/app/service/meta-tag/meta-tags.service';
import { isPlatformBrowser } from '@angular/common';

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

declare var adsbygoogle: any[];
@Component({
  selector: 'app-latest',
  templateUrl: './latest.component.html',
  styleUrls: ['./latest.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LatestComponent implements OnInit {
  latestPost = new Array();
  // mobile_news_div = true
  // lap_news_div = true
  hideads = true
  latestPostPagination = new Array()
  row_count: number = 100;

  config: any;
  collection = { count: 60, data: [] };


  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public responsive: boolean = true;
  public labels: any = {
    // previousLabel:"Previous",
    nextLabel: "Next",
    screenReaderPaginationLabel: 'Pagination',
    screenReaderPageLabel: 'page',
    screenReaderCurrentLabel: `You're on page`
  };
  value = 0

  constructor(private latestService: LatestService,
    private router: Router, private renderer2: Renderer2, private title: Title, private meta: Meta,
    private canonicalService: CanonicalService, private metaService: MetaTagsService, @Inject(PLATFORM_ID) private platformId: Object,) {

    this.config = {
      itemsPerPage: 5,
      currentPage: 1,
      totalItems: this.collection.count
    };
  }

  browser: any
  ngOnInit() {
    this.browser = isPlatformBrowser(this.platformId);
    this.canonicalService.destroyLinkForCanonicalURL()
    this.canonicalService.setCanonicalURL();
    this.metaService.setOgTags(TITLE_LATEST, DESCIPTION_BASE, 'https://cdn.newsfirst.lk/assets/TV-BG.jpg', "/latest");

    this.getLatestNews(0, 5)
    this.getPostByPagination(1, 5)
    this.title.setTitle(TITLE_LATEST)
    this.meta.updateTag(
      { name: 'description', content: DESCIPTION_BASE }
    )
 for (let index = 0; index < 10; index++) {
      try {
        (adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        //console.error("error");
      }

    }
  }

  // ngAfterViewInit() {
  //   if (this.browser) {
  //     for (let index = 0; index < 10; index++) {
  //       try {
  //         (adsbygoogle = window.adsbygoogle || []).push({});
  //       } catch (e) {
  //         //console.error("error");
  //       }

  //     }

  //   }
  // }

  paginatePage($event: PageEvent) {

    this.getPostByPagination($event.pageIndex, $event.pageSize);

  }

  getLatestNews(page: number, limit: number) {
    this.latestService.getAllNews(page, limit).subscribe((resp: any) => {

      this.latestPost = resp.postResponseDto
    })
  }

  getPostByPagination(page: number, limit: number) {
    this.latestService.getPostByPagination(page, limit).subscribe((resp: any) => {

      this.row_count = resp.rowCount
      this.latestPostPagination = resp.postResponseDto
      this.collection.data = resp.postResponseDto
      this.collection.count = resp.rowCount
      this.config = {
        itemsPerPage: limit,
        currentPage: page,
        totalItems: resp.rowCount
      };


    })
  }

  replaceString(str: string) {

    return str.replace(/(<([^>]+)>)/ig, '');
  }

  moveUp() {
    // window.scroll({
    //   top: 0,
    //   left: 0,
    //   behavior: 'smooth'
    // });
  }


  readMoreNews(id: number) {

    this.moveUp()
    this.router.navigate([`/news/${id}`]);
  }

  pageChanged(event: any) {

    this.config.currentPage = event;
    this.getPostByPagination(event, 5);
    const element = document.getElementById("testID");

    if (element != null) {
      element.scrollIntoView(true);
    }
  }

  postId(id: any) {

  }


}
